module.exports = __webpack_public_path__ + "static/media/trashRede7a37a75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/trashRed.svg
// module id = 337
// module chunks = 0